export function parseProductIds(value: string): number[]
{
    return Array.from(new Set(
        (value || '')
            .split(/[,\s;]+/)
            .map(part => Number.parseInt(part, 10))
            .filter(productId => Number.isFinite(productId) && productId > 0)
    ));
}

export const unwrapPayload = (result: any) => result?.payload ?? result;

export const currencyOptions =
[
    { id: 'PLN', label: 'PLN' },
    { id: 'EUR', label: 'EUR' },
    { id: 'USD', label: 'USD' }
];

export const defaultProfile =
{
    profileId: '',
    enabled: true,
    isActiveInStore: true,
    name: 'Polski / PL',
    languageId: null,
    languageName: '',
    contentLanguage: 'pl',
    feedLabel: 'PL',
    currencyCode: 'PLN',
    dataSourceName: '',
    dataSourceDisplayName: 'Connectico Products API - PL',
    sortOrder: 0
};

export function createGoogleMerchantProfileName(values: any)
{
    const contentLanguage = (values?.contentLanguage || '').trim().toLowerCase();
    const feedLabel = (values?.feedLabel || '').trim().toUpperCase();
    const currencyCode = (values?.currencyCode || '').trim().toUpperCase();

    return [contentLanguage, feedLabel, currencyCode]
        .filter(Boolean)
        .join(' / ');
}

export function createGoogleMerchantDataSourceDisplayName(values: any)
{
    const feedLabel = (values?.feedLabel || '').trim().toUpperCase();

    return feedLabel
        ? `Connectico Products API - ${feedLabel}`
        : 'Connectico Products API';
}